import Factory from 'factories/all';

export default function createIncomingWebFormItem(incomingWebForm, agent) {
  return Factory.build('WebFormItemWithDefaults', {
    content: {
      content: incomingWebForm.content,
    },
  });
}
